module.exports = __webpack_public_path__ + "media/images/common/shop/icon-review-fcf881488818c57d5145476375f28b2d.png";